import { lazy } from 'react';

const DeliveredMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/consults/delivered/material-info',
			component: lazy(() => import('./DeliveredMaterialContainer'))
		}
	]
};

export default DeliveredMaterialConfig;